import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getAvailableAggregateCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.AGGREGATE_CARDS,
		dtConfig[ModulesMap.AGGREGATE_CARDS].getAvailableAggregateCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getBasedAggregateCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.AGGREGATE_CARDS,
		dtConfig[ModulesMap.AGGREGATE_CARDS].getBasedAggregateCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getFullAggregateCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.AGGREGATE_CARDS,
		dtConfig[ModulesMap.AGGREGATE_CARDS].getFullAggregateCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedAggregateCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.AGGREGATE_CARDS,
		dtConfig[ModulesMap.AGGREGATE_CARDS].getExtendedAggregateCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

export default {
	getAvailableAggregateCards,
	getBasedAggregateCards,
	getExtendedAggregateCards,
	getFullAggregateCards,
}
